import { AxiosInstance } from "axios"
import { ResourceBooking } from "../../upcomingOrders/resourceBookings/userResourceBookingTypes"

export enum ArchiveResourceBooking {
    ARCHIVE_RESOURCE_BOOKING = "archive-resource-booking-for-user",
}

type FetchUserResourceBookingArchiveParams = Readonly<{
    userId: number
    resourceTypes?: string
    startDate?: string
    endDate?: string
}>

export type FetchUserResourceBookingArchiveResponse = Readonly<{
    orders: ResourceBooking[]
}>

export async function fetchUserResourceBookingArchive(
    { userId, ...rest }: FetchUserResourceBookingArchiveParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchUserResourceBookingArchiveResponse> {
    const url = `/users/${userId}/archive/bookings`

    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}

